// Modules
import React from 'react'

// Components
import { CPFPhasedLoginForm } from 'redesign/components/organisms/CPFPhasedLoginForm'
import { TemplateNewLogin } from 'redesign/components/templates'
import { Typography } from '@dasa-health/components-react'
import { Wrapper, CustomSpacing } from './styles'

// Application
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { WarningServiceIsDown } from '../WarningServiceIsDown'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any

export const CustomBrandEmphasisLogin = () => {
    const { title, subTitle } = useCurrentLaboratory()
    const { isAuthServiceDown } = useCPFLoginForm()
    const { isServiceDown } = isAuthServiceDown()

    return (
        <TemplateNewLogin>
            <Wrapper>
                <CustomSpacing lg={32} md={16} />
                <Typography as="h1" size={4} sx={{ fontWeight: '700' }}>
                    {title}
                </Typography>
                <CustomSpacing md={16} />
                <Typography as="h2" dangerouslySetInnerHTML={{ __html: subTitle }} size={1} weight={400} />
            </Wrapper>
            {isServiceDown && <WarningServiceIsDown />}
            <CPFPhasedLoginForm />
        </TemplateNewLogin>
    )
}
